import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';

/**
 *
 * IGateway is a marker interface for all Gateway-related interfaces.
 * This might be extended in the future with shared methods or properties.
 */
export interface IGateway {} // eslint-disable-line

export interface IGetGateway<INBOUND, OUTBOUND> extends IGateway {
  get(query: INBOUND): Observable<OUTBOUND>;
}

export interface IUploadGateway<INBOUND, OUTBOUND> extends IGateway {
  upload(query: INBOUND): Observable<OUTBOUND>;
}

export interface ISaveGateway<INBOUND, OUTBOUND> extends IGateway {
  save(query: INBOUND): Observable<OUTBOUND>;
}

export interface IPostGateway<INBOUND, OUTBOUND> extends IGateway {
  post(query: INBOUND): Observable<OUTBOUND>;
}

export interface IPutGateway<INBOUND, OUTBOUND> extends IGateway {
  put(query: INBOUND): Observable<OUTBOUND>;
}

export interface IDeleteGateway<INBOUND, OUTBOUND> extends IGateway {
  delete(query: INBOUND): Observable<OUTBOUND>;
}

export interface IListGateway<INBOUND, OUTBOUND> extends IGateway {
  list(query: INBOUND): Observable<OUTBOUND>;
}

export interface IDownloadGateway<INBOUND, OUTBOUND> extends IGateway {
  download(query: INBOUND): Observable<OUTBOUND>;
}

export abstract class ImportExportGateway<T, U = FormData, D = null>
  implements
    IUploadGateway<U, IApiResponse<T>>,
    IDownloadGateway<D, IApiResponse<string>>
{
  abstract upload(query: U): Observable<IApiResponse<T>>;
  abstract download(query?: D): Observable<IApiResponse<string>>;
}
